import { request, type Variables } from 'graphql-request';

import { GRAPHQL_GATEWAY_URL, AUTH_TOKEN_KEY } from '@/constants';
import type * as Dom from 'graphql-request/src/types.dom';

export const fetcher = <TData, TVariables extends Variables>(
  query: string,
  variables?: TVariables
): (() => Promise<TData>) => {
  const cookies = document.cookie.split(';').map((cookieString) => cookieString.trim());
  const authToken = cookies.find((cookie) => cookie.startsWith(`${AUTH_TOKEN_KEY}=`))?.split('=')?.[1];

  /* @todo: We might no longer be able to send the token in the header and retrieve it from the cookies directly on the b2b-gateway */
  const requestHeaders: Dom.RequestInit['headers'] = {};

  if (authToken) {
    requestHeaders.Authorization = `token ${authToken}`;
  }

  return async (): Promise<TData> => await request(GRAPHQL_GATEWAY_URL, query, variables, requestHeaders);
};
